import React, { useState, useEffect } from 'react'
import './TerritoryFilters.css'

const TerritoryFilters = ({ territories, onFilteredTerritories, onFiltersChange }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [sortBy, setSortBy] = useState('name')
  const [sortOrder, setSortOrder] = useState('asc')
  const [activityFilter, setActivityFilter] = useState('all')
  const [levelFilter, setLevelFilter] = useState('all')

  useEffect(() => {
    applyFilters()
  }, [searchTerm, sortBy, sortOrder, activityFilter, levelFilter, territories])

  const applyFilters = () => {
    let filtered = [...territories]

    // Aplicar búsqueda por nombre
    if (searchTerm.trim()) {
      filtered = filtered.filter(
        (territory) =>
          territory.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          territory.description.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }

    // Aplicar filtro por actividad reciente
    if (activityFilter !== 'all') {
      filtered = filtered.filter((territory) => territory.recentActivity === activityFilter)
    }

    // Aplicar filtro por nivel de actividad
    if (levelFilter !== 'all') {
      filtered = filtered.filter((territory) => territory.activityLevel === levelFilter)
    }

    // Aplicar ordenamiento
    filtered.sort((a, b) => {
      let aValue, bValue

      switch (sortBy) {
        case 'name':
          aValue = a.name.toLowerCase()
          bValue = b.name.toLowerCase()
          break
        case 'adventures':
          aValue = a.adventureCount || 0
          bValue = b.adventureCount || 0
          break
        case 'ninjas':
          aValue = a.characterCount || 0
          bValue = b.characterCount || 0
          break
        case 'activity':
          aValue = new Date(a.lastActivity || 0)
          bValue = new Date(b.lastActivity || 0)
          break
        default:
          aValue = a.name.toLowerCase()
          bValue = b.name.toLowerCase()
      }

      if (sortOrder === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
      }
    })

    onFilteredTerritories(filtered)

    // Notificar cambios en filtros para estadísticas
    if (onFiltersChange) {
      onFiltersChange({
        searchTerm,
        sortBy,
        sortOrder,
        activityFilter,
        levelFilter,
        totalResults: filtered.length,
      })
    }
  }

  const clearFilters = () => {
    setSearchTerm('')
    setSortBy('name')
    setSortOrder('asc')
    setActivityFilter('all')
    setLevelFilter('all')
  }

  const hasActiveFilters = searchTerm || activityFilter !== 'all' || levelFilter !== 'all' || sortBy !== 'name' || sortOrder !== 'asc'

  return (
    <div className="territory-filters territory-filters--toolbar">
      <div className="filters-header">
        <h3 className="filters-title">Buscar y filtrar territorios</h3>
        {hasActiveFilters && (
          <button className="clear-filters-btn" onClick={clearFilters}>
            Limpiar filtros
          </button>
        )}
      </div>

      <div className="filters-container">
        {/* Barra de búsqueda */}
        <div className="filter-group search-group">
          <label htmlFor="search" className="filter-label">
            Buscar territorio
          </label>
          <div className="search-input-container">
            <input
              type="text"
              id="search"
              className="search-input"
              placeholder="Buscar por nombre o descripción..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </div>
          </div>
        </div>

        {/* Filtros por categoría */}
        <div className="filter-group">
          <label htmlFor="activity-filter" className="filter-label">
            Actividad reciente
          </label>
          <select id="activity-filter" className="filter-select" value={activityFilter} onChange={(e) => setActivityFilter(e.target.value)}>
            <option value="all">Todas las actividades</option>
            <option value="Activo">Activo</option>
            <option value="Moderado">Moderado</option>
            <option value="Inactivo">Inactivo</option>
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="level-filter" className="filter-label">
            Nivel de actividad
          </label>
          <select id="level-filter" className="filter-select" value={levelFilter} onChange={(e) => setLevelFilter(e.target.value)}>
            <option value="all">Todos los niveles</option>
            <option value="Alto">Alto</option>
            <option value="Medio">Medio</option>
            <option value="Bajo">Bajo</option>
          </select>
        </div>

        {/* Ordenamiento */}
        <div className="filter-group">
          <label htmlFor="sort-by" className="filter-label">
            Ordenar por
          </label>
          <select id="sort-by" className="filter-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="name">Nombre</option>
            <option value="adventures">Número de aventuras</option>
            <option value="ninjas">Número de ninjas</option>
            <option value="activity">Actividad reciente</option>
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="sort-order" className="filter-label">
            Orden
          </label>
          <select id="sort-order" className="filter-select" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="asc">Ascendente</option>
            <option value="desc">Descendente</option>
          </select>
        </div>
      </div>
    </div>
  )
}

export default TerritoryFilters
